export default "__VITE_ASSET__c96fb760__"